import styled from "styled-components";
import {Typography} from "antd";

export const MyTextStyles = styled(Typography.Text)`
  margin-bottom: 0;
`